import {request, _urlBlogs, _urlProducts} from "../api";
import {BLOG_CONSTS, PRODUCT_CONSTS, UTIL_CONSTS} from "../constants";
import {LIMIT_GET_BLOGS} from "../../constants/constLimitCounts";
import {history} from "../../configs/history";
import {notificationSuccess} from "../../components/uiElements/Notifications";
import swal from "sweetalert";

export const GetBlogs = ({
                             reset = true,
                             offset = 0,
                             type,
                             isHidden=null,
                             text='',
                             limit = LIMIT_GET_BLOGS,

                         } = {}) => {
    let url = `${_urlBlogs}?offset=${offset}&limit=${limit}`;
    text && (url += `&text=${text}`);
    type && (url += `&type=${type}`);
    isHidden!==null && (url += `&isHidden=${isHidden}`);
    const requestData = {
        url,
        token: true,
        method: "GET",
    };

    return dispatch => {
        reset && dispatch({type: UTIL_CONSTS.START_LOADING});
        return request(requestData)
            .then(({data}) => {
                data && dispatch({
                    type: BLOG_CONSTS.GET_BLOGS,
                    payload: {
                        data: data,
                        reset,
                        hasMore: data.length === limit,
                    }
                });
            }).finally(() => {
                dispatch({
                    type: UTIL_CONSTS.END_LOADING
                })
            })
    }
};

export const GetBlogsInModal = ({
                             reset = true,
                             offset = 0,
                             type,
                             isHidden=null,
                             text='',
                             limit = LIMIT_GET_BLOGS,

                         } = {}) => {
    let url = `${_urlBlogs}?offset=${offset}&limit=${limit}`;
    text && (url += `&text=${text}`);
    type && (url += `&type=${type}`);
    isHidden!==null && (url += `&isHidden=${isHidden}`);
    const requestData = {
        url,
        token: true,
        method: "GET",
    };

    return dispatch => {
        reset && dispatch({type: UTIL_CONSTS.START_LOADING});
        return request(requestData)
            .then(({data}) => {
                data && dispatch({
                    type: BLOG_CONSTS.GET_BLOGS_IN_MODAL,
                    payload: {
                        data: data,
                        reset,
                        hasMore: data.length === limit,
                    }
                });
            }).finally(() => {
                dispatch({
                    type: UTIL_CONSTS.END_LOADING
                })
            })
    }
};

export const AddBlog = (data) => {
    const requestData = {
        url: _urlBlogs,
        token: true,
        method: "POST",
        data,
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                notificationSuccess({
                    description: "Բլոգը հաջողությամբ ստեղծվեց!"
                })
                history.push('/blogs')
            }).catch(e => {
                if (e?.response?.status === 409) {
                    swal({
                        title: "Չհաջողվեց!",
                        text: "Slug-ը արդեն օգտագործված է։",
                        icon: "error",
                        button: 'Լավ'
                    });
                }
            })
    }
};

export const UpdateBlog = (id, data) => {
    const requestData = {
        url: `${_urlBlogs}/${id}`,
        method: "PATCH",
        token: true,
        data,
    };

    return (dispatch) => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: BLOG_CONSTS.UPDATE_BLOG,
                    payload: data
                });
                notificationSuccess({
                    description: "Բլոգը հաջողությամբ փոփոխվեց!"
                })
                history.push({
                    pathname: '/blogs',
                })
            }).catch(e => {
                if (e?.response?.status === 409) {
                    swal({
                        title: "Չհաջողվեց!",
                        text: "Slug-ը արդեն օգտագործված է։",
                        icon: "error",
                        button: 'Լավ'
                    });
                }
            })
    }
};

export const GetBlogById = (id) => {
    const requestData = {
        url: `${_urlBlogs}/${id}`,
        method: "GET",
        token: true,
    };

    return (dispatch) => {
        return request(requestData)
            .then(({data}) => {
                return data
            })
    }
};

export const DeleteBlog = (id) => {
    const requestData = {
        url: `${_urlBlogs}/${id}`,
        token: true,
        method: "DELETE",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: BLOG_CONSTS.DELETE_BLOG,
                    payload: id
                });
                notificationSuccess({
                    description: "Բլոգը հաջողությամբ ջնջվեց!"
                })

            })
    }
};
